import { getSetupData } from '@booking-portal/api/services/initial-service';
import { useQuery } from '@tanstack/vue-query';
import type { MaybeRef } from '@vueuse/core';
import { computed, toValue } from 'vue';

export function useSetupDataQuery(
  locationId?: MaybeRef<number | undefined | null>
) {
  return useQuery({
    queryKey: ['setupData', locationId],
    queryFn: () => getSetupData(toValue(locationId)),
    staleTime: Number.MAX_SAFE_INTEGER,
    enabled: computed(() => toValue(locationId) !== undefined),
  });
}
